/**
 * @file BrandingSlot.tsx
 *
 * @fileoverview This component can be used to render something next to the logo.
 */

export const BrandingSlot = () => {
  return null;
};

export default BrandingSlot;
